import React from 'react';
import externalLink from '../../assets/external-link.png';


interface ExternalLinkProps {
  title: string;
  url: string;
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ title, url }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
        <img src={externalLink} alt="External Link" />
        <span>
            {title}
        </span>
    </a>
  );
};

export default ExternalLink;